import React from 'react';
import PropTypes from 'prop-types';
import { PageWrapper, Row, Col } from 'virtues-bootstrap';
import EmptyPage from 'components/EmptyPage';
import ResourcePage from 'containers/ResourcePage';
import Sidebar from 'containers/Resources/Sidebar';

const ResourcesPage = ({ isFaqPage, groupId, resourceId }) => (
  <PageWrapper>
    <Row>
      <Col xs={4}>
        <Sidebar openFaq={isFaqPage} groupId={groupId} />
      </Col>
      <Col xs={8}>
        {resourceId ? (
          <ResourcePage resourceId={resourceId} groupId={groupId} />
        ) : (
          <EmptyPage text="resources.selectResourceInSidebar" />
        )}
      </Col>
    </Row>
  </PageWrapper>
);

ResourcesPage.propTypes = {
  isFaqPage: PropTypes.bool.isRequired,
  groupId: PropTypes.string,
  resourceId: PropTypes.string,
};

ResourcesPage.defaultProps = {
  groupId: undefined,
  resourceId: undefined,
};

export default ResourcesPage;
